export default class LinkAnnotation {
  #label;
  #fromEntity;
  #toEntity;

  constructor(label, from, to) {
    this.#label = label;
    this.#fromEntity = from;
    this.#toEntity = to;
  }

  setLabel(label) {
    this.#label = label;
  }

  getLabel() {
    return this.#label;
  }

  setFromEntity(fromEntity) {
    this.#fromEntity = fromEntity;
  }

  getFromEntity() {
    return this.#fromEntity;
  }

  setToEntity(toEntity) {
    this.#toEntity = toEntity;
  }

  getToEntity() {
    return this.#toEntity;
  }
}
